module.exports = __webpack_public_path__ + "img/moren.a85fc909.png";